import { Component, inject, input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { KnobModule } from 'primeng/knob';
import { PanelModule } from 'primeng/panel';
import { PowerUnit } from '../../../../../constants/power_unit_enum';
import { IEnergyMeterList } from '../../../../../models/energy-meter';
import { Functions } from '../../../../../services/shared/functions';
import { IconsStyles } from '../../../../../services/shared/icons-styles';

@Component({
  selector: 'app-knob-view',
  imports: [KnobModule, PanelModule, FormsModule],
  templateUrl: './knob-view.html',
  styleUrl: './knob-view.css',
})
export class KnobView implements OnInit {
  readonly customFunctions = inject(Functions);
  energyMeterList = input.required<IEnergyMeterList[]>();
  readonly iconsStyles = inject(IconsStyles);
  powerUnit: PowerUnit = PowerUnit.W;

  ngOnInit(): void {}

  getValueTemplate(value: number): string {
    const converted = this.customFunctions.getConvertedPower(value);
    return `${converted.isExport ? '-' : ''}${converted.power} ${
      converted.powerUnit
    }`;
  }

  getMaxTemplate(value: number): number {
    const converted = this.customFunctions.getConvertedPower(value);
    if (converted.power < 0) {
      converted.power = converted.power * -1;
    }

    if (converted.power < 10 && converted.power >= 0) {
      return 10;
    } else if (converted.power < 100 && converted.power >= 10) {
      return 100;
    } else {
      return 1000;
    }
  }

  getValue(value: number): number {
    const converted = this.customFunctions.getConvertedPower(value);
    if (converted.power < 0) {
      converted.power = converted.power * -1;
    }
    return converted.power;
  }

  getValueColor(value: number): string {
    if (value < 0) {
      return '#0391d0';
    }

    return '#00703c';
  }
}
